import React, { useEffect } from 'react';
import SectionHeading from './section-headings';
import { Form, Radio, Input, Row, Col, Button } from 'antd'
import config from '../../config/form.json'
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { orgmode, showloader } from '../../store/gloabalState';
import { updateOrg, activeOrg, getOrgsDetails } from '../../services/httpCalls';
import useNotify from '../../utils/useNotify';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';

const OutwardDetails = ({
    handleChange,
    orgDetails
}) => {

    // * initializing form
    const [form] = Form.useForm();

    // * getting outward details config data
    const configData = config.outwardDetails[0];

    // * local states

    // * global states

    // * values
    const mode = useRecoilValue(orgmode)

    // * states

    // * updater/setter
    const setShowLoader = useSetRecoilState(showloader)

    // * constants/binders
    const navigate = useNavigate();
    const notify = useNotify();
    const handleChargeValidation = new RegExp(/^(\d+|\d*\.\d+)$/);

    const finalSubmit = async () => {
        setShowLoader(true);
        let orgId = localStorage.getItem("orgId")
        let userId = Cookies.get("userId")
        let opsUserId = JSON.parse(Cookies.get("userInfo")).id
        await activeOrg(orgId, userId, opsUserId)
            .then((res) => {
                if (res) {
                    notify.success("Created Organisation successfully!")
                    setTimeout(() => {
                        navigate('/orgs')
                    }, 700)
                }
            })
            .finally(() => {
                setShowLoader(false);
            })

    };

    const handleSubmit = async (values) => {
        let orgId = localStorage.getItem("orgId")
        let data = {
            outwardCommissionCharges: values.outwardCommissionCharges,
            outwardSwiftCharges: values.outwardSwiftCharges,
            "CB15Charges": parseInt(values["CB15Charges"]),
            "CA15Charges": parseInt(values["CA15Charges"]),
            "outwardFxCharges": values["outwardFxCharges"],
            "charteredAccountantChoice": values["charteredAccountantChoice"],
            outwardHubspotDealId:values.outwardHubspotDealId
        }
        await updateOrg(data, orgId)
            .then((res) => {
                if (res) {
                    try {
                        finalSubmit()
                        notify.success("Successfully posted Charges!")
                    }
                    catch {
                        notify.error("Error in posting Charges!")
                    }
                }
            })
            .catch((err) => {
                notify.success("Not able to post Charges!")
            })
    }

    useEffect(() => {
            const orgId = localStorage.getItem('orgId');
            getOrgsDetails(orgId)
                .then((res) => {
                    if (res) { 
                        if (res?.outwardCommissionCharges) {
                            form.setFieldsValue({
                                outwardCommissionCharges: res.outwardCommissionCharges,
                                outwardSwiftCharges: res.outwardSwiftCharges,
                                "CB15Charges": res["CB15Charges"],
                                "CA15Charges": res["CA15Charges"],
                                "outwardFxCharges": res["outwardFxCharges"],
                                "charteredAccountantChoice": res["charteredAccountantChoice"],
                                outwardHubspotDealId:res.outwardHubspotDealId
                            });
                        }

                    }
                })
    }, [form])

    const renderField = (field, index) => {
        const { type, label, name, props, style, tooltip} = field;

        // formatting rules
        field?.rules?.forEach(item => {
            if (item?.pattern) {
              item.pattern = eval(item?.pattern);
            } 
            if (item?.required) {
                item.required = eval(item?.required);
            }
            if (item?.validator) {
                item.validator = eval(item?.validator)
            }
        });
        
        switch (type) {
            case 'Form.Item':
                return (
                    <React.Fragment>
                        <Form.Item
                            label={label}
                            name={name}
                            rules={field?.rules}
                            tooltip={tooltip}
                            labelCol={field?.labelCol}
                            required={eval(field?.required)}
                        >      
                                {field?.children ? renderField(field?.children, 0) : null }
                        </Form.Item>
                        {field?.subFields ? field?.subFields.map((child, childIndex) => renderField(child, childIndex)) : null}
                    </React.Fragment>
                )
            case 'Input':
                return (
                    <Input
                        disabled={eval(props?.disabled)}
                        readOnly={eval(props?.readOnly)}
                        name={field?.name}
                        onKeyUp={eval(props?.onKeyUp)}
                     />
                );
            case 'Radio.Group':
                return (
                    <Radio.Group
                        defaultValue={field?.defaultValue}
                        onChange={eval(field?.onChange)}
                    >
                        {field?.children?.map((child, childIndex) => renderField(child, childIndex))}
                    </Radio.Group>
                )
            case 'Radio':
                return (
                    <Radio
                        value={field?.value}
                    >
                        {field?.label}
                    </Radio>
                )
            case 'SectionHeading':
                return (
                    <SectionHeading
                        style={field?.style}
                        level={field?.level}
                        heading={field?.heading}
                        Col={field?.Col}
                    />
                )
            default:
                return null;
        }
    }

    return(
        <Form
        {...configData.formConfig}
        form={form}
        disabled={ mode === 'view' }
        onFinish={handleSubmit}
        className={ mode === 'view' ? 'readonly' : '' }
        >
                <Row gutter={[16, 16]}>
                    {configData.fields.map((field, index) => {

                        // conditional render
                        const shouldRender = true;

                        return shouldRender && (
                            <Col key={index} span={field?.Col ? field.Col : 12}>
                                {renderField(field, index)}
                            </Col>
                        )
                    })} 
                </Row>  
                <div className='fixed_btn_wrap'>
                    <Button onClick={() => handleChange(orgDetails?.isOptInward ? 6 : 5)}>Previous</Button>
                    <Button type="primary" style={{ marginLeft: ".5rem" }} htmlType="submit">Submit</Button>
                </div>        
        </Form>
    )
}

export default OutwardDetails